<template>
  <div class="max-w-content-sm md:max-w-content-md mx-auto my-10 lg:my-15">
    <div v-if="loading" class>
      <p class="text-center text-18 md:text-20">Loading Charities...</p>
    </div>
    <div class="p-2.5 md:px-5 xl:px-0 md:py-5 md:grid grid-cols-3 gap-4">
      <div v-for="(charity, index) in charities" :key="index" class="w-full mb-2.5 md:mb-0">
        <a :href="getUrl(charity.slug)" class="block">
          <img v-if="charity.image" :src="charity.image.url" :alt="charity.image.alt_text">
        </a>
      </div>
    </div>
    <div v-if="error" class="py-5 md:py-15 text-center mx-auto max-w-screen-sm lg:max-w-content-sm">
      <p class="text-18 md:text-20">
        {{ error }}
      </p>
      <button class="button block mx-auto min-w-280 md:min-w-360" @click.prevent="getCharities">
        Try again
      </button>
    </div>
  </div>
</template>

<script>
import Route from '../src/Route';

export default {

  data() {
    return {
      charities: [],
      loading: false,
      error: null,
    };
  },

  created() {
    this.getCharities();
  },

  methods: {
    getCharities() {
      this.loading = true;
      this.error = null;

      axios
        .get(Route('json.charities.index'))
        .then((response) => {
          if (response.status === 200) {
            this.charities = response.data.charities;
          } else {
            throw 'There was a problem.';
          }
        })
        .catch((error) => {
          this.error = 'Sorry there was a problem loading charities.';
        })
        .then(() => {
          this.loading = false;
        });
    },

    getUrl(slug) {
        return Route('charities.show', {charity: slug});
    },
  },


}
</script>
